(function () {
  document.querySelectorAll('.combo-landing').forEach(initComboLanding);

  function initComboLanding(root) {
    var picksMin = parseInt(root.dataset.picksRequired, 10) || 2;
    var picksMax = Math.max(parseInt(root.dataset.picksMax, 10) || picksMin, picksMin);
    var comboPrice = parseFloat(root.dataset.comboPrice) || 0;
    var unitPrice = parseFloat(root.dataset.unitPrice) || 0;
    var selected = [];
    var prioritySelected = true;
    var priorityVariantId = "68353619263731";

    var cards = root.querySelectorAll('[data-product-card]');
    var buyButtons = root.querySelectorAll('[data-buy-button]');
    var clearButton = root.querySelector('[data-clear-selection]');
    var countLabels = root.querySelectorAll('[data-selected-count], [data-selected-count-sticky]');
    var errorEl = root.querySelector('[data-selection-error]');
    var grid = root.querySelector('.cl-grid');
    var summary = root.querySelector('.cl-summary');
    var waBtn = root.querySelector('[data-whatsapp-btn]');
    var fullToast = root.querySelector('[data-full-toast]');
    var totalLabel = root.querySelector('[data-total-label]');
    var buyPrice = root.querySelector('[data-buy-price]');
    var fullToastTimer = null;
    var errorTimer = null;


    // Shipping notice: one pair costs $20,000 to ship; two or more ship free.
    var shippingDialog = document.createElement('dialog');
    shippingDialog.className = 'cl-shipping-dialog';
    shippingDialog.setAttribute('aria-labelledby', 'cl-shipping-heading');
    shippingDialog.innerHTML = '<button type="button" class="cl-shipping-close" aria-label="Cerrar aviso de envío">×</button><div class="cl-shipping-icon" aria-hidden="true">🍋</div><p class="cl-shipping-kicker">COMPLETA TU COMBO</p><h2 id="cl-shipping-heading">¡Tu segundo par lleva el envío gratis!</h2><p>Si llevas <strong>solo 1 sandalia</strong>, tu envío cuesta <strong>$20.000</strong>.</p><div class="cl-shipping-offer"><b>2 sandalias por $' + money(comboPrice) + '</b><span>Envío gratis · Combina diseños y tallas</span></div><button type="button" class="cl-shipping-add">Elegir mi segunda sandalia</button><button type="button" class="cl-shipping-single">Continuar con 1 + $20.000 de envío</button>';
    root.appendChild(shippingDialog);
    var shippingReturnFocus = null, shippingBuyButton = null;
    var shippingNote = document.createElement('p');
    shippingNote.className = 'cl-shipping-note';
    shippingNote.setAttribute('role','status');
    if (summary) summary.appendChild(shippingNote);
    var shippingStyle = document.createElement('style');
    shippingStyle.textContent = '.cl-shipping-dialog{box-sizing:border-box;border:1px solid #ebd786;border-radius:24px;width:min(460px,calc(100vw - 28px));max-height:calc(100dvh - 32px);padding:30px 27px;background:#fffdf5;color:#292519;text-align:center;box-shadow:0 20px 80px #0004;font-family:inherit;overflow:auto}.cl-shipping-dialog::backdrop{background:#13100699;backdrop-filter:blur(3px)}.cl-shipping-dialog h2{font-size:27px;line-height:1.1;margin:12px 0 18px;color:#292519;letter-spacing:-.025em}.cl-shipping-dialog p{font-size:15px;line-height:1.6;margin:10px 0}.cl-shipping-close{position:absolute;top:10px;right:12px;background:transparent;border:0;width:32px;height:32px;font-size:25px;cursor:pointer;color:#6c6248}.cl-shipping-icon{font-size:36px}.cl-shipping-dialog .cl-shipping-kicker{font-size:10px;font-weight:800;letter-spacing:.15em;color:#8c701d}.cl-shipping-offer{background:#fff2bd;border-radius:13px;padding:16px 10px;margin:20px 0;display:grid;gap:6px}.cl-shipping-offer b{font-size:23px}.cl-shipping-offer span{font-size:12px}.cl-shipping-add{border:0;background:#ffce00;color:#222;width:100%;padding:16px 8px;border-radius:12px;font:700 15px inherit;cursor:pointer}.cl-shipping-single{border:0;background:transparent;color:#665b3e;width:100%;padding:14px 2px 2px;font:12px inherit;text-decoration:underline;cursor:pointer}.cl-shipping-note{font-size:13px;font-weight:700;margin:10px 0;width:100%;color:#65511b}.cl-shipping-dialog button:focus-visible{outline:3px solid #8b6700;outline-offset:3px}@media(max-width:480px){.cl-shipping-dialog{padding:25px 20px}.cl-shipping-dialog h2{font-size:25px}}';
    document.head.appendChild(shippingStyle);
    function closeShippingNotice() { shippingDialog.close(); if(shippingReturnFocus && shippingReturnFocus.isConnected) shippingReturnFocus.focus(); }
    function showShippingNotice(checkout, btn) { shippingReturnFocus=document.activeElement;shippingBuyButton=checkout?btn:null;if(!shippingDialog.open)shippingDialog.showModal(); }
    shippingDialog.querySelector('.cl-shipping-close').onclick=closeShippingNotice;
    shippingDialog.querySelector('.cl-shipping-add').onclick=function(){closeShippingNotice();if(grid)grid.scrollIntoView({behavior:'smooth',block:'start'});};
    shippingDialog.querySelector('.cl-shipping-single').onclick=function(){var btn=shippingBuyButton||buyButtons[0];shippingDialog.close();if(selected.length===1&&btn)showPriorityReview(btn);};
    shippingDialog.addEventListener('click',function(e){if(e.target===shippingDialog){var b=shippingDialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)closeShippingNotice();}});
    function updateShippingCopy(n) {
      if (shippingNote) shippingNote.textContent=n===1?'1 par: $'+money(unitPrice)+' · Envío estándar $20.000'+(prioritySelected?' · Prioritario +$7.900':'')+' · Total $'+money(currentTotal()):'Envío estándar gratis desde 2 sandalias.'+(n&&prioritySelected?' Servicio prioritario opcional: +$7.900.':'');
      if(summary){var walker=document.createTreeWalker(summary,NodeFilter.SHOW_TEXT),nodes=[],node;while(node=walker.nextNode()){if(/\+?\s*Envío Gratis/i.test(node.nodeValue)&&!shippingNote.contains(node))nodes.push(node);}nodes.forEach(function(t){t.nodeValue=n===1?' · Envío incluido ($20.000)':' + Envío gratis desde 2 pares';});}
    }


    var priorityBox=document.createElement('label');priorityBox.className='cl-priority-option';priorityBox.innerHTML='<input type="checkbox" checked><span><b>🚚 Envío prioritario +$7.900</b><small>Servicio opcional. Puedes quitarlo antes de comprar.</small></span>';
    if(summary)summary.insertBefore(priorityBox,shippingNote);
    var priorityInput=priorityBox.querySelector('input');priorityInput.addEventListener('change',function(){prioritySelected=this.checked;render();});
    var review=document.createElement('dialog');review.className='cl-shipping-dialog cl-priority-review';review.setAttribute('aria-labelledby','cl-priority-title');review.innerHTML='<button type="button" class="cl-shipping-close" aria-label="Cerrar resumen">×</button><p class="cl-shipping-kicker">REVISA TU PEDIDO</p><h2 id="cl-priority-title">Tu selección está lista</h2><div class="cl-review-products"></div><div class="cl-review-subtotal"></div><div class="cl-review-shipping"></div><label class="cl-priority-option"><input type="checkbox" checked><span><b>🚚 Envío prioritario +$7.900</b><small>Opcional. Desmárcalo si prefieres el envío estándar.</small></span></label><div class="cl-review-total" role="status"></div><button type="button" class="cl-shipping-add cl-priority-confirm">Continuar a datos de compra →</button><button type="button" class="cl-shipping-single cl-priority-back">Seguir eligiendo</button>';
    root.appendChild(review);var reviewBuyButton=null,reviewInput=review.querySelector('input');
    var extraStyle=document.createElement('style');extraStyle.textContent='.cl-priority-option{box-sizing:border-box;display:flex;align-items:flex-start;gap:10px;text-align:left;padding:16px;border:1px solid #e5d784;border-radius:14px;background:#fff7d5;cursor:pointer;margin:14px 0;width:100%}.cl-priority-option input{width:19px;height:19px;flex-shrink:0;accent-color:#c49a00;margin:2px 0}.cl-priority-option b{display:block;font-size:14px;color:#30270e;line-height:1.4}.cl-priority-option small{display:block;font-size:11px;color:#75643b;line-height:1.5;margin-top:4px}.cl-review-products{max-height:170px;overflow:auto;text-align:left;margin:15px 0}.cl-review-row{display:flex;align-items:center;gap:12px;padding:8px 0;border-bottom:1px solid #eee6cb;font-size:12px}.cl-review-row img{width:48px;height:48px;object-fit:contain;border-radius:9px}.cl-review-subtotal,.cl-review-shipping{text-align:left;font-size:13px;margin:10px 0}.cl-review-total{display:flex;justify-content:space-between;font-size:23px;font-weight:800;border-top:1px solid #e3d9b5;margin:18px 0;padding-top:16px}.cl-priority-review h2{font-size:26px}.cl-priority-option:has(input:checked){border-color:#d2ad00;background:#fff2b6}';document.head.appendChild(extraStyle);
    function updatePriorityReview(){reviewInput.checked=prioritySelected;priorityInput.checked=prioritySelected;review.querySelector('.cl-review-subtotal').textContent='Sandalias: $'+money(selected.length*unitPrice);review.querySelector('.cl-review-shipping').textContent=selected.length===1?'Envío estándar: $20.000':'Envío estándar: GRATIS';review.querySelector('.cl-review-total').textContent='Total: $'+money(currentTotal());}
    function showPriorityReview(btn){reviewBuyButton=btn;var list=review.querySelector('.cl-review-products');list.replaceChildren();selected.forEach(function(id){var c=root.querySelector('[data-product-card][data-product-id="'+id+'"]');if(!c)return;var row=document.createElement('div'),img=document.createElement('img'),txt=document.createElement('span');row.className='cl-review-row';img.src=c.querySelector('img').src;img.alt=c.dataset.productTitle;txt.textContent=c.dataset.productTitle+' · Talla '+c.querySelector('[data-size-select]').selectedOptions[0].textContent.trim();row.append(img,txt);list.append(row);});updatePriorityReview();if(!review.open)review.showModal();}
    reviewInput.addEventListener('change',function(){prioritySelected=this.checked;render();updatePriorityReview();});
    review.querySelector('.cl-shipping-close').onclick=function(){review.close();};review.querySelector('.cl-priority-back').onclick=function(){review.close();};
    review.querySelector('.cl-priority-confirm').onclick=function(){review.close();if(selected.length&&reviewBuyButton)addComboToCart(reviewBuyButton);};

    function money(n) {
      return String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function currentTotal() {
      return (selected.length === 1 ? unitPrice + 20000 : (selected.length >= picksMin ? selected.length * unitPrice : comboPrice)) + (selected.length && prioritySelected ? 7900 : 0);
    }

    cards.forEach(function (card) {
      var toggle = card.querySelector('[data-card-toggle]');
      var sizeSelect = card.querySelector('[data-size-select]');

      if (sizeSelect) {
        sizeSelect.addEventListener('click', function (e) { e.stopPropagation(); });
      }

      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var id = card.dataset.productId;
        var idx = selected.indexOf(id);
        var adding = idx === -1;

        if (!adding) {
          selected.splice(idx, 1);
          card.classList.remove('is-selected');
        } else {
          if (selected.length >= picksMax) {
            showError('Máximo ' + picksMax + ' pares por pedido. Si quieres cambiar alguno, primero deselecciónalo.');
            return;
          }
          selected.push(id);
          card.classList.add('is-selected');
        }
        render();

        if (!adding) return;
        var n = selected.length;
        if (n === 1) showShippingNotice(false);

        if (n === picksMax) {
          if (summary) {
            setTimeout(function () {
              summary.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 250);
          }
          showToast(picksMax === picksMin
            ? '✅ ¡Ya elegiste tus ' + picksMax + ' sandalias! Si quieres cambiar alguna, primero deselecciónala (toca la que ya elegiste).'
            : '✅ Llegaste al máximo de ' + picksMax + ' pares. Si quieres cambiar alguno, primero deselecciónalo.');
        } else if (n === picksMin) {
          showToast('✅ ¡Ya tienes tu promo (' + picksMin + ' X $' + money(comboPrice) + ')! Si quieres llevar más, elige otros: cada par extra suma $' + money(unitPrice) + ' (máximo ' + picksMax + ').');
        }
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        selected = [];
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        render();
      });
    }

    buyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (selected.length < 1 || selected.length > picksMax) return;
        if (selected.length === 1) { showShippingNotice(true, btn); return; }
        showPriorityReview(btn);
      });
    });

    function render() {
      var n = selected.length;
      var ready = n >= 1;
      countLabels.forEach(function (el) { el.textContent = n; });
      buyButtons.forEach(function (btn) { btn.disabled = !ready; });
      if (ready && errorEl) errorEl.hidden = true;
      if (grid) grid.classList.toggle('is-full', n >= picksMax);
      var total = currentTotal();
      if (totalLabel) totalLabel.textContent = '$' + money(total);
      if (buyPrice) buyPrice.textContent = money(total);
      updateShippingCopy(n);
      updateWhatsappMessage();
    }

    function updateWhatsappMessage() {
      if (!waBtn) return;
      var number = waBtn.dataset.waNumber;
      var message;

      if (selected.length === 0) {
        message = waBtn.dataset.waDefaultMessage;
      } else {
        var names = selected.map(function (id) {
          var card = root.querySelector('[data-product-card][data-product-id="' + id + '"]');
          return card ? card.dataset.productTitle : id;
        });
        message = 'Hola, estuve en la página de Lemon Shoes armando mi pedido de ' + selected.length + (selected.length === 1 ? ' par' : ' pares') + ' y elegí: ' + names.join(', ') + '. ¿Me ayudan a confirmar el pedido?';
      }

      waBtn.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    }

    function showError(msg) {
      if (!errorEl) return;
      clearTimeout(errorTimer);
      errorEl.textContent = msg;
      errorEl.hidden = false;
      errorTimer = setTimeout(function () { errorEl.hidden = true; }, 3500);
    }

    function showToast(msg) {
      if (!fullToast) return;
      clearTimeout(fullToastTimer);
      fullToast.textContent = msg;
      fullToast.hidden = false;
      requestAnimationFrame(function () {
        fullToast.classList.add('is-visible');
      });
      fullToastTimer = setTimeout(function () {
        fullToast.classList.remove('is-visible');
        setTimeout(function () { fullToast.hidden = true; }, 300);
      }, 4500);
    }

    function addComboToCart(btn) {
      var n = selected.length;
      var items = selected.map(function (id) {
        var card = root.querySelector('[data-product-card][data-product-id="' + id + '"]');
        var chosenVariantId = card ? card.dataset.defaultVariantId : id;

        if (card) {
          var sizeSelect = card.querySelector('[data-size-select]');
          if (sizeSelect && sizeSelect.value) {
            chosenVariantId = sizeSelect.value;
          }
        }

        return {
          id: chosenVariantId,
          quantity: 1,
          properties: { 'Combo': n === 1 ? '1 sandalia · envío $20.000' : 'Promo ' + picksMin + ' X $' + money(comboPrice) + ' - pedido de ' + n + ' pares' }
        };
      });

      if (prioritySelected) items.push({id: priorityVariantId, quantity: 1});
      var originalHtml = btn.innerHTML;
      btn.disabled = true;
      btn.textContent = 'Agregando...';

      window.location.href = '/cart/' + items.map(function(item){ return item.id + ':' + item.quantity; }).join(',');

    }

    updateWhatsappMessage();
    initBannerCarousel(root);
    initTestimonialCarousel(root);
  }

  function initBannerCarousel(root) {
    var carousel = root.querySelector('[data-banner-carousel]');
    if (!carousel) return;

    var track = carousel.querySelector('[data-banner-track]');
    var slides = track.children;
    var dots = carousel.querySelectorAll('[data-banner-dot]');
    if (slides.length < 2) return;

    var seconds = parseInt(carousel.dataset.bannerSeconds, 10) || 0;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = null;
    var pausedUntil = 0;

    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }

    function goTo(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    function syncDots() {
      var idx = current();
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }

    track.addEventListener('scroll', syncDots, { passive: true });
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { pausedUntil = Date.now() + 8000; goTo(i); });
    });

    ['touchstart', 'pointerdown', 'wheel'].forEach(function (evt) {
      track.addEventListener(evt, function () { pausedUntil = Date.now() + 8000; }, { passive: true });
    });

    if (seconds > 0 && !reduceMotion) {
      timer = setInterval(function () {
        if (document.hidden || Date.now() < pausedUntil) return;
        goTo((current() + 1) % slides.length);
      }, seconds * 1000);
    }

    window.addEventListener('resize', function () { track.scrollLeft = current() * track.clientWidth; });
  }

  function initTestimonialCarousel(root) {
    var carousel = root.querySelector('[data-testimonial-carousel]');
    if (!carousel) return;

    var viewport = carousel.querySelector('[data-testimonial-viewport]');
    var track = carousel.querySelector('[data-testimonial-track]');
    var cards = track.querySelectorAll('.cl-testimonial-card');
    var prevBtn = carousel.querySelector('[data-testimonial-prev]');
    var nextBtn = carousel.querySelector('[data-testimonial-next]');
    var dots = carousel.querySelectorAll('[data-testimonial-dot]');
    var index = 0;

    function step() {
      if (!cards.length) return 0;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0);
      return cards[0].getBoundingClientRect().width + gap;
    }

    function maxIndex() {
      var visible = Math.max(1, Math.floor(viewport.clientWidth / step()));
      return Math.max(0, cards.length - visible);
    }

    function update() {
      var max = maxIndex();
      if (index > max) index = max;
      if (index < 0) index = 0;
      track.style.transform = 'translateX(-' + (index * step()) + 'px)';
      if (prevBtn) prevBtn.disabled = index === 0;
      if (nextBtn) nextBtn.disabled = index >= max;
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        index -= 1;
        update();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        index += 1;
        update();
      });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        index = i;
        update();
      });
    });

    window.addEventListener('resize', update);
    update();

    // Swipe / arrastre táctil
    var startX = 0;
    var currentX = 0;
    var dragging = false;

    track.addEventListener('touchstart', function (e) {
      dragging = true;
      startX = e.touches[0].clientX;
      currentX = startX;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      currentX = e.touches[0].clientX;
      var delta = currentX - startX;
      track.style.transform = 'translateX(' + (-(index * step()) + delta) + 'px)';
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var delta = currentX - startX;
      if (delta < -40) {
        index += 1;
      } else if (delta > 40) {
        index -= 1;
      }
      update();
    });

    // Arrastre con mouse (desktop)
    var mouseDown = false;
    track.addEventListener('mousedown', function (e) {
      mouseDown = true;
      startX = e.clientX;
      currentX = startX;
      track.style.transition = 'none';
      track.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', function (e) {
      if (!mouseDown) return;
      currentX = e.clientX;
      var delta = currentX - startX;
      track.style.transform = 'translateX(' + (-(index * step()) + delta) + 'px)';
    });
    window.addEventListener('mouseup', function () {
      if (!mouseDown) return;
      mouseDown = false;
      track.style.transition = '';
      track.style.cursor = 'grab';
      var delta = currentX - startX;
      if (delta < -40) {
        index += 1;
      } else if (delta > 40) {
        index -= 1;
      }
      update();
    });
  }
})();




/* CRO 2026-10 — mejoras progresivas sin alterar el banner principal */
(function () {
  function initCro(root) {
    if (!root || root.dataset.croEnhanced === 'true') return;
    root.dataset.croEnhanced = 'true';

    var picker = root.querySelector('.cl-picker');
    var hero = root.querySelector('.cl-hero');
    var trust = root.querySelector('.cl-trust-strip');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-product-card]'));
    var sticky = root.querySelector('.cl-sticky-bar');
    var min = parseInt(root.dataset.picksRequired, 10) || 2;

    if (hero && picker && !hero.querySelector('.cl-hero-cta')) {
      var priceSub = hero.querySelector('.cl-price-sub');
      if (priceSub) {
        var perPair = document.createElement('span');
        perPair.className = 'cl-price-per-pair';
        perPair.textContent = '$49.950 cada par al llevar 2';
        priceSub.insertAdjacentElement('afterend', perPair);
      }
      var cta = document.createElement('a');
      cta.className = 'cl-hero-cta';
      cta.href = '#selector-sandalias';
      cta.innerHTML = '<span>Elegir mis 2 pares<small>Tallas 35 a 43 · Envío gratis</small></span>';
      hero.appendChild(cta);
    }

    if (trust && picker && picker.parentNode === root) {
      root.insertBefore(trust, picker);
    }

    if (picker) {
      var title = picker.querySelector('.cl-picker-title');
      var help = picker.querySelector('.cl-picker-help');
      if (title) title.textContent = 'Elige tus 2 pares favoritos';
      if (help) help.textContent = 'Lleva 2 pares con envío gratis. Si eliges solo 1, el envío cuesta $20.000. Combina diseños y tallas diferentes.';
      if (!picker.querySelector('.cl-selection-steps')) {
        var steps = document.createElement('div');
        steps.className = 'cl-selection-steps';
        steps.innerHTML = '<div class="cl-selection-step"><strong>1</strong>Elige diseño</div><div class="cl-selection-step"><strong>2</strong>Selecciona talla</div><div class="cl-selection-step"><strong>3</strong>Agrega 2 pares</div>';
        var grid = picker.querySelector('.cl-grid');
        if (grid) grid.insertAdjacentElement('beforebegin', steps);
      }
    }

    cards.forEach(function (card, index) {
      var titleEl = card.querySelector('.cl-card-title');
      var select = card.querySelector('[data-size-select]');
      if (titleEl) {
        titleEl.textContent = titleEl.textContent.replace(/^Sandalias\s+/i, '').replace(/^Lemon Shoes\s+/i, '');
      }
      if (!card.querySelector('.cl-selected-badge')) {
        var selectedBadge = document.createElement('span');
        selectedBadge.className = 'cl-selected-badge';
        card.appendChild(selectedBadge);
      }
      if (!card.querySelector('.cl-product-badge') && (index === 0 || index >= Math.max(cards.length - 4, 1))) {
        var productBadge = document.createElement('span');
        productBadge.className = 'cl-product-badge';
        productBadge.textContent = index === 0 ? 'POPULAR' : 'NUEVA';
        card.appendChild(productBadge);
      }
      if (!card.querySelector('.cl-combo-price')) {
        var comboPrice = document.createElement('span');
        comboPrice.className = 'cl-combo-price';
        comboPrice.textContent = 'En combo: $49.950 por par';
        if (titleEl) titleEl.insertAdjacentElement('afterend', comboPrice);
      }
      if (select && !card.querySelector('.cl-size-label')) {
        var sizeLabel = document.createElement('span');
        sizeLabel.className = 'cl-size-label';
        sizeLabel.textContent = 'Elige tu talla';
        select.insertAdjacentElement('beforebegin', sizeLabel);
        var guide = document.createElement('button');
        guide.type = 'button';
        guide.className = 'cl-size-guide-btn';
        guide.setAttribute('data-size-guide', '');
        guide.textContent = '¿Cómo elegir mi talla?';
        select.insertAdjacentElement('afterend', guide);
      }
    });

    if (!root.querySelector('.cl-guide-modal')) {
      var modal = document.createElement('div');
      modal.className = 'cl-guide-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-label', 'Guía para elegir talla');
      modal.innerHTML = '<div class="cl-guide-card"><button type="button" class="cl-guide-close" aria-label="Cerrar guía">×</button><h3>Elige tu talla con confianza</h3><p>Usa la talla que normalmente compras en Colombia.</p><p><strong>¿Estás entre dos tallas?</strong> Elige la talla mayor para un ajuste más cómodo.</p><p>Si necesitas cambiarla, cuentas con cambios gratis.</p></div>';
      root.appendChild(modal);
      modal.addEventListener('click', function (event) {
        if (event.target === modal || event.target.closest('.cl-guide-close')) modal.hidden = true;
      });
    }

    if (sticky && !sticky.querySelector('.cl-sticky-message')) {
      var stickyMessage = document.createElement('span');
      stickyMessage.className = 'cl-sticky-message';
      var progress = document.createElement('span');
      progress.className = 'cl-progress-shell';
      progress.innerHTML = '<span class="cl-progress-fill"></span>';
      sticky.insertBefore(stickyMessage, sticky.firstChild);
      sticky.insertBefore(progress, sticky.firstChild);
    }

    function updateCro() {
      var chosen = cards.filter(function (card) { return card.classList.contains('is-selected'); });
      cards.forEach(function (card) {
        var badge = card.querySelector('.cl-selected-badge');
        var position = chosen.indexOf(card);
        if (badge) badge.textContent = position >= 0 ? 'PAR ' + (position + 1) + ' ELEGIDO' : '';
      });
      var ready = chosen.length >= min;
      root.classList.toggle('is-combo-ready', ready);
      var stickyMessage = root.querySelector('.cl-sticky-message');
      var fill = root.querySelector('.cl-progress-fill');
      if (stickyMessage) {
        stickyMessage.textContent = ready ? chosen.length + ' pares listos · Envío gratis' : 'Te falta' + (min - chosen.length === 1 ? ' 1 par' : 'n ' + (min - chosen.length) + ' pares');
      }
      if (fill) fill.style.width = Math.min(100, (chosen.length / min) * 100) + '%';
      var salesPopup = document.querySelector('[id*="sales_popup"], [class*="sales-popup"]');
      if (salesPopup) salesPopup.classList.toggle('cl-hide-social-proof', ready);
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-size-guide]')) {
        event.preventDefault();
        var modal = root.querySelector('.cl-guide-modal');
        if (modal) modal.hidden = false;
        return;
      }
      if (event.target.closest('[data-card-toggle]') || event.target.closest('[data-clear-selection]')) {
        window.setTimeout(updateCro, 20);
      }
    });
    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-size-select]')) window.setTimeout(updateCro, 0);
    });
    updateCro();
  }

  function startCro() {
    document.querySelectorAll('.combo-landing').forEach(initCro);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startCro);
  else startCro();
})();

(function(){document.querySelectorAll('.combo-landing details').forEach(function(d){if(/envío es gratis/i.test(d.querySelector('summary')?.textContent||'')){var p=d.querySelector('p');if(p)p.textContent='El envío es gratis al llevar 2 sandalias. Si compras solo 1 sandalia, el envío cuesta $20.000 y se suma al total antes de confirmar tu pedido.';}});})();
